import Component from '@averyano/core/src/classes/Component';

import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ParagraphAnimation from '../../animations/Paragraph';
import ContactForm from './contact-form';
GSAP.registerPlugin(ScrollTrigger);

import each from 'lodash/each';

export default class ContactSection extends Component {
	constructor() {
		super({
			element: '.contact',
			elements: {
				video: '.cover__video',
				wm: '#wordmark2',
			},
		});
	}

	create() {
		super.createComponent();
		this.components = {
			contactForm: new ContactForm(),
		};

		each(this.components, (component) => {
			component.create();
		});

		this.isCreated = true;
		this.createTimeline();
	}

	createTimeline() {
		if (window.isMobile) return;
	}

	addEventListeners() {
		each(this.components, (component) => {
			component.addEventListeners();
		});
	}

	removeEventListeners() {
		each(this.components, (component) => {
			component.removeEventListeners();
		});
	}

	clearTimeline() {}

	destroy() {
		super.destroy();
		this.clearTimeline();
	}
}
